import React from 'react'

class Notice extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <path
          fill="#343638"
          fillRule="nonzero"
          d="M15.249 5.051l-1.05 1.5H1.5v13h17V8.254L20 6.111v14.94H0v-16h15.249zm-6.08 10.5l-.052 1H3.5v-1h5.669zm6.331 0v1h-3.447l.906-.383.43-.617H15.5zm-5.244-1.625l2.048 1.434-2.171.92.123-2.354zm8.317-11.878l2.048 1.434-8.03 11.468-2.048-1.434 8.03-11.468zM9.997 12.55l-.7 1H3.5v-1h6.497zm6.503 0v1h-1.71l.7-1h1.01zm-4.402-3l-.701 1H3.5v-1h8.598zM20.007 0l2.048 1.434-1.147 1.638-2.048-1.434L20.007 0z"
        />
      </svg>
    )
  }
}

export default Notice
